import { CUPOS_TOTAL, CUPOS_VENDIDOS } from '../data/config';

export type TimeLeft = { days: number; hours: number; minutes: number; seconds: number };

/** Porcentaje de cupos vendidos, o null si no está configurado. */
export function getCuposPercent(): number | null {
  if (CUPOS_TOTAL === null || CUPOS_VENDIDOS === null || CUPOS_TOTAL <= 0) return null;
  return Math.min(100, Math.max(0, Math.round((CUPOS_VENDIDOS / CUPOS_TOTAL) * 100)));
}

const pad = (value: number) => value.toString().padStart(2, '0');

export function formatCountdown(time: TimeLeft): string {
  const clock = `${pad(time.hours)}:${pad(time.minutes)}:${pad(time.seconds)}`;
  return time.days > 0 ? `${time.days}d ${clock}` : clock;
}

export function padTime(value: number): string {
  return pad(value);
}
